import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faAlarmSnooze,
  faArrowsAltH,
  faCarBump,
  faCarCrash,
  faCheck,
  faClipboardCheck,
  faClock,
  faExclamationTriangle,
  faEye,
  faMapMarkedAlt,
  faPlayCircle,
  faReplyAll,
  faRoad,
  faSearch,
  faShareAlt,
  faSteeringWheel,
  faTachometerAltFastest,
  faTachometerAltSlow,
  faTasks,
  faTimes,
  faUsers,
  faFileCheck,
  faTrafficCone,
  faCalendarExclamation,
  faTruck,
} from '@fortawesome/pro-light-svg-icons';
import { StatPanelComponent } from './stat-panel.component';

@NgModule({
  declarations: [StatPanelComponent],
  exports: [StatPanelComponent],
  imports: [CommonModule, FontAwesomeModule],
})
export class StatPanelModule {
  constructor(library: FaIconLibrary) {
    // Font Awesome Icons to consume
    library.addIcons(
      faAlarmSnooze,
      faArrowsAltH,
      faCarBump,
      faCarCrash,
      faCheck,
      faClipboardCheck,
      faClock,
      faExclamationTriangle,
      faEye,
      faMapMarkedAlt,
      faPlayCircle,
      faReplyAll,
      faRoad,
      faSearch,
      faShareAlt,
      faSteeringWheel,
      faTachometerAltFastest,
      faTachometerAltSlow,
      faTasks,
      faTimes,
      faUsers,
      faFileCheck,
      faTrafficCone,
      faCalendarExclamation,
      faTruck
    );
  }
}
